import React from 'react';

/**
 * Aviso — mensagem fixa do sistema. Não é a central de toasts (`avisar`).
 * tom: 'sucesso' | 'atencao' | 'perigo' | 'info'. Perigo usa role="alert"; os outros, role="status".
 */
const ICONES = { sucesso: 'check_circle', atencao: 'warning', perigo: 'error', info: 'info' };

export default function Aviso({ tom = 'info', titulo, acao, children }) {
  return (
    <div className={`sj-aviso sj-aviso--${tom}`} role={tom === 'perigo' ? 'alert' : 'status'}>
      <span className="sj-icone sj-aviso__icone" aria-hidden="true">{ICONES[tom]}</span>
      <div className="sj-aviso__texto">
        {titulo && <strong>{titulo}</strong>}
        <div>{children}</div>
      </div>
      {acao}
    </div>
  );
}
